import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";
import { toast } from "sonner";
import { INSTALL_HELP, isIOSDevice, isStandalone, useInstallPrompt } from "@/lib/pwa";
import { track } from "@/lib/track";

const SEEN_KEY = "apollo_install_banner_seen";

// Banner "Installa l'app": solo su telefono, solo alla prima visita
export const InstallBanner = () => {
  const [show, setShow] = useState(false);
  const { canInstall, install } = useInstallPrompt();

  useEffect(() => {
    const phone = window.matchMedia("(max-width: 767px) and (pointer: coarse)").matches;
    if (!phone || isStandalone() || localStorage.getItem(SEEN_KEY)) return undefined;
    const t = setTimeout(() => {
      localStorage.setItem(SEEN_KEY, "1");
      setShow(true);
    }, 2500);
    return () => clearTimeout(t);
  }, []);

  if (!show) return null;
  const close = () => setShow(false);
  const onInstall = async () => {
    track("click_scarica_app", { platform: "banner" });
    close();
    if (!isIOSDevice() && canInstall && (await install())) return;
    toast("Installa Apollo.AI", { description: INSTALL_HELP[isIOSDevice() ? "ios" : "android"] });
  };

  return (
    <div data-testid="install-banner" role="dialog" aria-label="Installa l'app"
      className="fade-up fixed bottom-5 left-4 right-24 z-[55] flex items-center gap-2 border border-slate-200 bg-white p-2.5 shadow-xl">
      <img src="/icon-192.png" alt="" className="h-10 w-10 shrink-0 rounded-lg" />
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-semibold text-slate-900">Installa l'app</p>
        <p className="truncate text-xs text-slate-500">Apollo.AI</p>
      </div>
      <button type="button" data-testid="install-banner-install" onClick={onInstall}
        className="flex shrink-0 items-center gap-1 bg-slate-900 px-2.5 py-2 text-xs font-bold text-white transition-colors hover:bg-emerald-500 hover:text-slate-900">
        <Download className="h-3.5 w-3.5" /> Installa
      </button>
      <button type="button" data-testid="install-banner-close" onClick={close} aria-label="Chiudi"
        className="shrink-0 p-1 text-slate-400 transition-colors hover:text-slate-900">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
